import { AxiosInstance } from 'axios';

export function withCredentials(axios: AxiosInstance) {
  axios.defaults.withCredentials = true;
}
